import { Card } from '@moia-dev/pace-web'
import { useTranslation } from 'react-i18next'
import { MoiaViewBox } from '../basics/MoiaViewBox'
import { NoDataState } from '../patterns/NoDataState/NoDataState'
import { PictureConstructionSite } from '../patterns/NoDataState/PictureConstructionSite'

type EmptyStateProps = {
  title: string
  description?: React.ReactNode
}

export const MoiaEmptyState = ({ title, description }: EmptyStateProps) => {
  const { t } = useTranslation()

  return (
    <MoiaViewBox>
      <Card
        css={{
          alignItems: 'center',
          display: 'flex',
          minHeight: `calc(100vh - 112px)`,
        }}
      >
        <NoDataState
          title={title}
          description={
            description ? (
              description
            ) : (
              <>
                {t('patterns_emptyStateDescription')}
                <br />
                {t('patterns_emptyStateCallToAction')}
              </>
            )
          }
          picture={<PictureConstructionSite />}
        />
      </Card>
    </MoiaViewBox>
  )
}
